if (!customElements.get('blog-list')) {
  class BlogList extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        gridItem: '.blogs-list-redesign__grid-item',
        gridVisibleItem: '.blogs-list-redesign__grid-item.is-visible',
        observerTrigger: '.blogs-list-redesign--observer-trigger',
      };

      this.modifiers = {
        visibleItem: 'is-visible',
      };

      this.gridItemsCount = 6;
      this.gridItems = this.querySelectorAll(this.selectors.gridItem);
    }

    connectedCallback() {
      this.setupObserver();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    setupObserver() {
      const trigger = this.querySelector(this.selectors.observerTrigger);

      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.loadMoreArticles();
        }
      }, { threshold: 0.1 });

      this.observer.observe(trigger);
    }

    loadMoreArticles() {
      const visibleItems = this.querySelectorAll(this.selectors.gridVisibleItem);

      if (visibleItems.length >= this.gridItems.length) {
        this.observer.disconnect();

        return;
      }

      [...this.gridItems].slice(visibleItems.length, visibleItems.length + this.gridItemsCount)
        .forEach(item => item.classList.add(this.modifiers.visibleItem));
    }
  }

  customElements.define('blog-list', BlogList);
}
